"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRules = exports.JurisdictionRules = exports.FederalRules = exports.FederalOnlyRules = exports.JURISDICTIONS = exports.KNOWN_JURISDICTIONS = void 0;
exports.isKnownJurisdiction = isKnownJurisdiction;
exports.resolveAccumulation = resolveAccumulation;
exports.resolveAccumulationThresholds = resolveAccumulationThresholds;
const facilityState_1 = require("../../facilityState");
const CA_1 = require("./CA");
const CT_1 = require("./CT");
const DE_1 = require("./DE");
const FEDERAL_1 = require("./FEDERAL");
const FL_1 = require("./FL");
const MA_1 = require("./MA");
const MN_1 = require("./MN");
const MO_1 = require("./MO");
const VT_1 = require("./VT");
/**
 * Adding a state means one class file under this directory — carrying its
 * own expectations, which the sweep holds it to — and one registry entry
 * below. A state's numbers are regulatory law: verify them against that
 * state's own regulations, never assume them from another state's.
 */
/**
 * The jurisdictions the registry makes claims about — deliberately not a
 * `when` axis; the sweep runs once per jurisdiction. Anything absent falls
 * back to federal law, a property the runner checks rather than a set of
 * rows.
 */
exports.KNOWN_JURISDICTIONS = [
    "FEDERAL",
    "CA",
    "CT",
    "DE",
    "FL",
    "MA",
    "MN",
    "MO",
    "VT",
];
function isKnownJurisdiction(value) {
    return exports.KNOWN_JURISDICTIONS.some((j) => j === value);
}
// Note that the federal rules will automatically be used for a
// valid 2-letter state abbreviation that is missing from here, so no need
// to create entries for a state that just uses the federal rules.
//
// Additionally, note that these are singletons instantiated at module load;
// These classes should never carry any state, only static constants and
// pure functions.
exports.JURISDICTIONS = {
    FEDERAL: new FEDERAL_1.FederalOnlyRules(),
    CA: new CA_1.CaliforniaRules(),
    CT: new CT_1.ConnecticutRules(),
    DE: new DE_1.DelawareRules(),
    FL: new FL_1.FloridaRules(),
    MA: new MA_1.MassachusettsRules(),
    MN: new MN_1.MinnesotaRules(),
    MO: new MO_1.MissouriRules(),
    VT: new VT_1.VermontRules(),
};
/**
 * The class answering for a facility's state: null resolves under federal
 * law, an unseeded state or junk input falls back to federal.
 */
function jurisdictionRulesFor(state) {
    const parsed = (0, facilityState_1.parseFacilityState)(state);
    if (parsed === null || !isKnownJurisdiction(parsed)) {
        return exports.JURISDICTIONS.FEDERAL;
    }
    return exports.JURISDICTIONS[parsed];
}
function resolveAccumulation(jurisdiction, ctx) {
    return jurisdictionRulesFor(jurisdiction).resolve(ctx);
}
function resolveAccumulationThresholds(jurisdiction, ctx) {
    return jurisdictionRulesFor(jurisdiction).resolveAccumulationThresholds(ctx);
}
var FEDERAL_2 = require("./FEDERAL");
Object.defineProperty(exports, "FederalOnlyRules", { enumerable: true, get: function () { return FEDERAL_2.FederalOnlyRules; } });
Object.defineProperty(exports, "FederalRules", { enumerable: true, get: function () { return FEDERAL_2.FederalRules; } });
Object.defineProperty(exports, "JurisdictionRules", { enumerable: true, get: function () { return FEDERAL_2.JurisdictionRules; } });
Object.defineProperty(exports, "StateRules", { enumerable: true, get: function () { return FEDERAL_2.StateRules; } });
//# sourceMappingURL=index.js.map